import React from 'react'

import { FeaturedPrice } from '../../../PriceLayout'
import OfferPriceNetWithFees from '../OfferPriceNetWithFees'
import type { OfferPriceProps } from '../types'

const OfferPriceNetWithFeesDaily = (props: OfferPriceProps) => {
  return <OfferPriceNetWithFees {...props} featuredPrice={FeaturedPrice.PerNight} />
}

export default OfferPriceNetWithFeesDaily
